import React from 'react';
import { sanitizeHtml } from '../utils/sanitizeHtml';
import './HtmlContent.css';

/** Quita etiquetas HTML para obtener texto plano (para recortar o preview). */
const stripHtml = (html) => String(html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();

/**
 * Muestra contenido que puede ser HTML (de CKEditor) o texto plano.
 * Si contiene etiquetas HTML, se renderiza como HTML; si no, como texto.
 * maxLength: si se pasa, en vista recortada se muestra texto sin HTML y se trunca; si no hay maxLength se muestra el HTML completo.
 */
const HtmlContent = ({ content, className, tag: Tag = 'div', maxLength }) => {
  if (content == null || content === '') return null;
  const str = String(content).trim();
  if (!str) return null;

  const looksLikeHtml = /<[a-z][\s\S]*>/i.test(str);

  if (maxLength) {
    const plain = looksLikeHtml ? stripHtml(str) : str;
    const toShow = plain.length > maxLength ? plain.substring(0, maxLength) + '...' : plain;
    return <Tag className={className}>{toShow}</Tag>;
  }

  if (looksLikeHtml) {
    const cn = [className, 'html-content'].filter(Boolean).join(' ');
    // Mitigación XSS: sanitizar el HTML antes de renderizarlo en el DOM.
    const safeHtml = sanitizeHtml(str);
    return (
      <Tag
        className={cn}
        dangerouslySetInnerHTML={{ __html: safeHtml }}
      />
    );
  }
  return <Tag className={className}>{str}</Tag>;
};

export default HtmlContent;
export { stripHtml };
